import { render, staticRenderFns } from "./TempBusiness.vue?vue&type=template&id=d9b104c2&scoped=true&"
import script from "./TempBusiness.vue?vue&type=script&lang=js&"
export * from "./TempBusiness.vue?vue&type=script&lang=js&"
import style0 from "./TempBusiness.vue?vue&type=style&index=0&id=d9b104c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b104c2",
  null
  
)

export default component.exports